import React from 'react';
import './Auth.css';

function RadioGroup({ label, options, selected, onChange, required = false }) {
  return (
    <div className="radio-group">
      <label className="input-label">
        {label}{required && <span className="required">*</span>}
      </label>
      <div className="radio-options">
        {options.map((option) => (
          <label key={option.value} className="radio-option">
            <input
              type="radio"
              name="userType"
              value={option.value}
              checked={selected === option.value}
              onChange={() => onChange(option.value)}
            />
            <span className="radio-label">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export default RadioGroup;
